module.exports = __webpack_public_path__ + "img/8386741.png";